import { TPoCardOrderInfo, TRESPONSE_PO_DETAILS_CARD } from '@monorepo/types';
import { ModifiersZTableModel } from '../../table.modifier';
import { TTableCellType, TTableOptions, TTextCell } from '../../table.type';
import * as moment from 'moment';

const createHeaderRow = (headerInfo: TRESPONSE_PO_DETAILS_CARD['field_info']): TTableOptions['headerConfig'] => {
  const headerRow = [
    ...headerInfo.map((hInfo) => {
      return {
        type: 'TEXT_CELL',
        text: hInfo.order_field_key_info['display_name'],
        liftedInput: {
          input: {
            type: hInfo.edit_info.input_type || 'INPUT',
            subType: hInfo.edit_info.input_sub_type || 'text',
            options: hInfo.edit_info.values?.map((_) => ({ value: _ })),
            setValue: (v: TPoCardOrderInfo) => v.fields[hInfo.order_field_key_info['key']],
          },
          metadata: {
            keyName: hInfo.order_field_key_info['key'],
            isRequired: !hInfo.edit_info.editable,
            noEditsInTable: !hInfo.edit_info.editable,
          },
        },
      };
    }),
    {
      type: 'TEXT_CELL',
      text: '',
      widthInPx: 32,
      stickyType: 'RIGHT',
    },
  ] as TTextCell[];
  return headerRow;
};

const getRows = (
  headerInfo: TRESPONSE_PO_DETAILS_CARD['field_info'],
  rowItem: TRESPONSE_PO_DETAILS_CARD['orders'][number],
) => {
  const rows = [
    ...headerInfo.map((hInfo) => {
      return {
        type: 'TEXT_CELL',
        text:
          hInfo.order_field_key_info.data_type === 'DATE'
            ? moment(rowItem.fields[hInfo.order_field_key_info['key']]).format('D MMM')
            : rowItem.fields[hInfo.order_field_key_info['key']],
      };
    }),
    {
      type: 'ACTION_CELL',
      actionType: 'ASSIGN',
      asIcon: true,
    },
  ] as TTableCellType[];
  return rows;
};

export const PO_DETAILS_CARD_TABLE_MODEL = {
  createModel: (poDetails: TRESPONSE_PO_DETAILS_CARD, isEditDisabled: boolean) => {
    return ModifiersZTableModel.createTableModel(
      poDetails.orders,
      {
        edit: {
          hasAddRow: false,
          hasDeleteRow: !isEditDisabled,
          disableEdit: isEditDisabled,
          stickyType: 'RIGHT',
        },
        headerConfig: createHeaderRow(poDetails.field_info),
      },
      (item) => {
        return {
          type: 'ROW',
          rowItem: item,
          cells: getRows(poDetails.field_info, item),
        };
      },
    );
  },
};
